import { CONTACT_KINDS } from './../../shared/js/constants';

import { isEmpty, orderBy } from 'lodash';

export const getPrimaryEmailAndPhone = (contactMethods) => {
    let result = { email: '', phone: '' };

    if (!contactMethods) {
        return result;
    }

    const emailContact = contactMethods.find(
        (contact) => contact.isPrimary && contact.kind === CONTACT_KINDS.EMAIL
    );

    if (emailContact) {
        result.email = emailContact.value;
    }

    const phoneContact = contactMethods.find(
        (contact) => contact.isPrimary && contact.kind === CONTACT_KINDS.PHONE
    );

    if (phoneContact) {
        result.phone = phoneContact.value;
    }

    return result;
};

export const getContentTemplate = (templates, type, appCode) => {
    if (isEmpty(templates)) {
        return undefined;
    }

    const appCodes = [appCode, ''];

    const appSpecificTemplates = orderBy(templates, 'appCode', 'desc').filter(
        (x) => x.type === type && appCodes.includes(x.appCode)
    );

    if (!isEmpty(appSpecificTemplates)) {
        return appSpecificTemplates[0];
    }

    return undefined;
};
